import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAkOHweTk8q71bwWWQIT0yrTHaJkPF2RII",
  authDomain: "bee-happy-preschool.firebaseapp.com",
  projectId: "bee-happy-preschool",
  storageBucket: "bee-happy-preschool.firebasestorage.app",
  messagingSenderId: "1155383057",
  appId: "1:1155383057:web:1239be824d8334774696b0",
  measurementId: "G-GM0GG1ZW7R"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);
export { db, auth, analytics };
